import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPycharmComponent } from './simple-icons-pycharm.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPycharmComponent ],
    exports:      [ SimpleIconsPycharmComponent ],
    bootstrap:    []
})
export class SimpleIconsPycharmModule {}
